import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🏠", key: "myWall" },
  { emoji: "📱", key: "socialMedia" },
  { emoji: "💌", key: "friendsFamily" },
  { emoji: "🌍", key: "everywhere" },
]

export default function PetsShareWithWhoPage() {
  return (
    <RadioCardListPage translationKey="petsShareWithWho" options={OPTIONS} />
  )
}
